import { render, staticRenderFns } from "./GenerationHistoryListItemDesign.vue?vue&type=template&id=63c3daf9"
import script from "./GenerationHistoryListItemDesign.vue?vue&type=script&lang=js"
export * from "./GenerationHistoryListItemDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports